import { useCallback, useEffect, useState } from 'react'
import { listCampaigns } from '../services/campaignsApi'
import type { Campaign } from '../types'

export function useCampaigns(workspaceId: string) {
  const [campaigns, setCampaigns] = useState<Campaign[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    listCampaigns(workspaceId)
      .then((result) => { if (!cancelled) setCampaigns(result) })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load campaigns') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [workspaceId])

  useEffect(() => load(), [load])

  return { campaigns, loading, error, retry: load }
}
